export function fillRef(ref, node) {
    if (typeof ref === 'function') {
        ref(node);
    }
    else if (ref) {
        ref.current = node;
    }
}
//# sourceMappingURL=fillRef.js.map